import React, { useEffect, useMemo, useState } from 'react'
import style from "./index.module.css";
import { BiUpArrow } from 'react-icons/bi';
import { isMobile } from 'react-device-detect';

// Old OPTIONS (JASMINE/LOTUS) — preserved for reference
// const OPTIONS = [
//     { value: null, label: "All" },
//     { value: '9', label: '9' },
//     { value: '12', label: '12' },
//     // { value: '16', label: '16' },
//     { value: '18', label: '18' },
//     { value: '24', label: '24' },
//     { value: '27', label: '27' },
//     { value: '36', label: '36' },
//     { value: '48', label: '48' },
//     // { value: '54', label: '54' },
//     { value: '60', label: '60' },
//     { value: '72', label: '72' },
//     // { value: '90', label: '90' },
//     // { value: '108', label: '108' },
// ]

const OPTIONS = [
    { value: null, label: "All" },
    { value: '9', label: '9' },
    { value: '12', label: '12' },
    { value: '16', label: '16' },
    { value: '18', label: '18' },
    // { value: '24', label: '24' },
    { value: '27', label: '27' },
    { value: '36', label: '36' },
    // { value: '48', label: '48' },
    { value: '54', label: '54' },
    // { value: '60', label: '60' },
    { value: '72', label: '72' },
    // { value: '90', label: '90' },
    { value: '108', label: '108' },
]

export const MyDropDown = ({ className, options = OPTIONS, onChnage = () => { }, children, autoWidth, isOpen: isOpenProp, onOpenChange, nested = false }) => {
    const [isOpenInternal, setisOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState(options[0])
    const isControlled = typeof isOpenProp === "boolean"
    const isOpen = isControlled ? isOpenProp : isOpenInternal

    const maxChr = useMemo(() => {
        let len = 0
        options.forEach(d => {
            if (d.label.length > len) {
                len = d.label.length
            }
        })
        return len
    }, [options])

    useEffect(() => {
        onChnage(selectedOption);
        if (isControlled) {
            onOpenChange && onOpenChange(false);
        } else {
            setisOpen(false);
        }
    }, [selectedOption])

    return (
        <>
            <div className={`${className || ""} ${style.filterKit} ${nested ? style.nested : ""}`}
                style={autoWidth ? {
                    width: `${maxChr}ch`
                } : {}}>
                <div className={`${style.filterArea} ${style.dflex}`} onClick={(e) => {
                    e.preventDefault();
                    const nextOpen = !isOpen;
                    if (isControlled) {
                        onOpenChange && onOpenChange(nextOpen);
                    } else {
                        setisOpen(nextOpen);
                    }
                }}>
                    {
                        children(selectedOption)
                    }
                    <BiUpArrow className={style.arrowIcon} style={isOpen ? {
                        transform: "rotate(0deg)"
                    } : {
                        transform: "rotate(180deg)"
                    }} />
                </div>
                <div className={`${style.optionContainer} ${isOpen ? style.open : ""}`}
                    style={autoWidth ? {
                        width: `${maxChr}ch`,
                        minWidth: "100%"
                    } : {}}
                >
                    {
                        options.map(_o => (

                            <div className={style.option} key={_o.label} onClick={(e) => {
                                e.preventDefault();
                                setSelectedOption(_o)
                            }}>
                                {
                                    _o.label
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}